var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2740_36625",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2740_36625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.33333 9.66667C3.96667 9.66667 3.65278 9.53611 3.39167 9.275C3.13056 9.01389 3 8.7 3 8.33333C3 7.96667 3.13056 7.65278 3.39167 7.39167C3.65278 7.13056 3.96667 7 4.33333 7C4.7 7 5.01389 7.13056 5.275 7.39167C5.53611 7.65278 5.66667 7.96667 5.66667 8.33333C5.66667 8.7 5.53611 9.01389 5.275 9.275C5.01389 9.53611 4.7 9.66667 4.33333 9.66667ZM8.33333 9.66667C7.96667 9.66667 7.65278 9.53611 7.39167 9.275C7.13056 9.01389 7 8.7 7 8.33333C7 7.96667 7.13056 7.65278 7.39167 7.39167C7.65278 7.13056 7.96667 7 8.33333 7C8.7 7 9.01389 7.13056 9.275 7.39167C9.53611 7.65278 9.66667 7.96667 9.66667 8.33333C9.66667 8.7 9.53611 9.01389 9.275 9.275C9.01389 9.53611 8.7 9.66667 8.33333 9.66667ZM12.3333 9.66667C11.9667 9.66667 11.6528 9.53611 11.3917 9.275C11.1306 9.01389 11 8.7 11 8.33333C11 7.96667 11.1306 7.65278 11.3917 7.39167C11.6528 7.13056 11.9667 7 12.3333 7C12.7 7 13.0139 7.13056 13.275 7.39167C13.5361 7.65278 13.6667 7.96667 13.6667 8.33333C13.6667 8.7 13.5361 9.01389 13.275 9.275C13.0139 9.53611 12.7 9.66667 12.3333 9.66667Z",
    fill: "#E2E2E2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/three-dots.ba7431d7f5f09fd02c484c68aa13900f.svg";
export { ForwardRef as ReactComponent };